import React = require("react");
import {Status, checkStatus, default as ProgressStatus} from "./ProgressStatus";
import * as Dispatcher from "./ProgressDialogDispatcher";

export enum Layout {
    SPINNER,
    STEPS
}

interface ProgressTaskProps extends React.Props<ProgressTask> {
    title: string;
    state: Status;
    index: number;
    identifier: string;
    followedBy: string[];
    layout?: Layout;
}

interface ProgressTaskState {
    actualState: Status;
}

export default class ProgressTask extends React.Component<ProgressTaskProps, ProgressTaskState> {

    styles = {
        root: {
            width: "30%",
            paddingTop: "10px"
        },
        active: {
            color: "#222222"
        },
        task: {
            display: "block",
            textAlign: "center",
            margin: "auto",
            paddingTop: "10px"
        }
    };

    constructor(props: ProgressTaskProps) {
        super(props);

        this.state = {
            actualState: this.props.state
        };

        this.changeState = this.changeState.bind(this);
        Dispatcher.register(this.props.identifier, this.changeState);
    }

    /**
     * This get called BEFORE the component get removed from DOM.
     * It removes the task from the Dispatcher register.
     */
    componentWillUnmount() {
        Dispatcher.unregister(this.props.identifier);
    }

    /**
     * This callback is registered at the PorgressDialogDispatcher so it get called with every dispatch.
     * It will look in the payload if the field identifier is equals to the own identifier.
     *
     * @param payload
     */
    changeState(payload: any) {
        this.setState({
            actualState: checkStatus(this, this.state.actualState, payload)
        });
    }

    /**
     * Returns the component view
     *
     * @returns JSX.Element
     */
    render() {
        let activeStyle = Object.assign({}, this.styles.root, this.styles.active);
        let style = (this.state.actualState === Status.RUNNING) ? activeStyle : this.styles.root;

        return <div style={style} id={this.props.identifier}>
            <ProgressStatus
                layout={this.props.layout}
                value={this.state.actualState}
                index={this.props.index}
            />
            <span style={this.styles.task}>{this.props.title}</span>
        </div>;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/progress-dialog/ProgressTask.tsx
 **/